<div class="cg-dialog">
  <h2 class="cg-dialog__header">
    Site Help
    <button
      cignaButton="link inline no-underline"
      class="cg-dialog__close_new"
      (click)="dialogRef.close()"
    >
      Close
      <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <p>
      View below for a list of frequently asked questions. Please call us at 1
      (800) 981-9114 if your question is not addressed below.
    </p>
    <cigna-collapsible-item
      headerText="How do I check a patient's eligibility on the portal?"
    >
      <p>
        Go to the "Patients" dropdown in the main navigation at the top of the
        page and select "Search Patients". Follow the search instructions on the
        screen.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="How do I obtain a patient's ID card?">
      <p>
        Go to the "Patients" dropdown in the main navigation at the top of the
        page and select "Search Patients". Search for your patient and then
        select the "Patient ID Card" link next to the patient's name. A digital
        ID card will appear, and you can print it directly from there.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="What steps should I take to ensure the security of my information?"
    >
      <p>
        Steps for requesting prior authorization or precertification vary
        depending on your specialty. Visit
        <a
          rel="noopener noreferrer"
          data-test-id="lnk-precert-resources"
          target="_blank"
          href="https://www.cigna.com/health-care-providers/coverage-and-claims/precertification"
          >Precertification Resources
        </a>
        for specific details.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="How do I check claim status?">
      <p>
        To view statuses, go to the "Claims" dropdown in the main navigation at
        the top of the page and select "Search Claims”. Choose from the options
        displayed to search for the claim(s).
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="Are there any training resources available to help me use the portal more effectively?"
      ><p>
        Yes, specialty-focused training resources are available in the
        "Education Training and Tutorials" section at the bottom of the page.
      </p>
    </cigna-collapsible-item>

    <cigna-collapsible-item
      headerText="How can I view or update my multi-factor authentication (MFA) settings?"
    >
      <p>
        MFA authentication adds an extra layer of security for your patient and
        provider information. To change your MFA settings, navigate to the
        “Settings & Preferences” section under your name in the upper right
        corner of the homepage. Then, select the “Security & Login” link in the
        lefthand column.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="How do I get access to additional Tax Identification Numbers (TINs) on my existing account?"
    >
      <p>
        To add TINs to your account, navigate to the “Settings & Preferences”
        section under your name in the upper right corner of the homepage.
        Select “Online Access” and then “Add TIN”. If you are not a web access
        manager for the account, a notification will be sent to your web access
        manager to approve your access request.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Any other site questions?">
      <p>Contact our support team at 1 (800) 981-9114 for help.</p>
    </cigna-collapsible-item>
  </mat-dialog-content>
</div>
